import { Send, Loader2, Edit } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";

export const PreviewEmailDialog = ({ open, onOpenChange, payment, onSend }) => (
      <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-2xl">
      <DialogHeader>
        <DialogTitle>Email Preview</DialogTitle>
      </DialogHeader>
      {payment && (
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <span className="text-slate-500">To:</span>
              <p className="font-medium">{payment.provider}</p>
            </div>
            <div>
              <span className="text-slate-500">Subject:</span>
              <p className="font-medium">Payment Follow-up - Invoice {payment.provider_invoice_no}</p>
            </div>
          </div>
          <div className="p-4 bg-slate-50 rounded-lg whitespace-pre-wrap text-sm">
            {payment.email_draft}
          </div>
        </div>
      )}
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>
          Close
        </Button>
        {payment?.status === "draft" && (
          <Button 
            onClick={() => {
              onSend(payment);
              onOpenChange(false);
            }}
            className="bg-[#425B76] hover:bg-[#2D4156]"
          >
            <Send className="w-4 h-4 mr-2" />
            Send Email
          </Button>
        )}
      </DialogFooter>
    </DialogContent>
      </Dialog>
);

export const EditDraftDialog = ({ open, onOpenChange, payment, editedDraft, setEditedDraft, onSave, saving }) => (
      <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-2xl">
      <DialogHeader>
        <DialogTitle>Edit Draft Email</DialogTitle>
      </DialogHeader>
      {payment && (
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <span className="text-slate-500">Provider:</span>
              <p className="font-medium">{payment.provider}</p>
            </div>
            <div>
              <span className="text-slate-500">Invoice:</span>
              <p className="font-medium">{payment.provider_invoice_no}</p>
            </div>
          </div>
          <Textarea
            value={editedDraft}
            onChange={(e) => setEditedDraft(e.target.value)}
            rows={12}
            className="font-mono text-sm"
          />
        </div>
      )}
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>
          Cancel
        </Button>
        <Button 
          onClick={onSave}
          className="bg-[#425B76] hover:bg-[#2D4156]"
        >
          Save Draft
        </Button>
      </DialogFooter>
    </DialogContent>
      </Dialog>
);

export const SendEmailDialog = ({ open, onOpenChange, payment, providerEmail, setProviderEmail, onConfirm, sending }) => (
      <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle>Send Email to Provider</DialogTitle>
      </DialogHeader>
      {payment && (
        <div className="space-y-4">
          <div className="text-sm">
            <p className="text-slate-500">Provider:</p>
            <p className="font-medium">{payment.provider}</p>
          </div>
          <div className="text-sm">
            <p className="text-slate-500">Invoice:</p>
            <p className="font-medium">{payment.provider_invoice_no}</p>
          </div>
          <div>
            <label className="text-sm text-slate-600 block mb-2">
              Provider Email Address <span className="text-red-500">*</span>
            </label>
            <Input
              type="email"
              placeholder="provider@email.com"
              value={providerEmail}
              onChange={(e) => setProviderEmail(e.target.value)}
              data-testid="provider-email-input"
            />
            <p className="text-xs text-slate-400 mt-1">
              Email will be sent from support@talentdesk.io
            </p>
          </div>
        </div>
      )}
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>
          Cancel
        </Button>
        <Button 
          onClick={onConfirm}
          disabled={sending || !providerEmail}
          className="bg-[#425B76] hover:bg-[#2D4156]"
        >
          {sending ? (
            <>
              <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              Sending...
            </>
          ) : (
            <>
              <Send className="w-4 h-4 mr-2" />
              Send Email
            </>
          )}
        </Button>
      </DialogFooter>
    </DialogContent>
      </Dialog>
);

